export default __webpack_public_path__ + "static/media/gallery-3.2597123b.jpg";